// extracted by mini-css-extract-plugin
export var collapse = "style-module--collapse--808fd";
export var collapse__content = "style-module--collapse__content--9ac5f";
export var collapse__headline = "style-module--collapse__headline--ba6e7";